import { ComparisonOperator } from "@evergis/ui";

export const BASE_OPERATORS = [ComparisonOperator.Equals, ComparisonOperator.NotEquals];

export const CONTAINS_OPERATORS = [ComparisonOperator.Contains, ComparisonOperator.NotContains];

export const FILLED_OPERATORS = [ComparisonOperator.Filled, ComparisonOperator.Empty];

export const STARTS_WITH_OPERATORS = [ComparisonOperator.StartsWith, ComparisonOperator.NotStartsWith];

export const ENDS_WITH_OPERATORS = [ComparisonOperator.EndsWith, ComparisonOperator.NotEndsWith];

export const RANGE_OPERATORS = [
  ComparisonOperator.LessThan,
  ComparisonOperator.LessOrEquals,
  ComparisonOperator.GreaterThan,
  ComparisonOperator.GreaterOrEquals,
];

export const BETWEEN_OPERATORS = [ComparisonOperator.Between, ComparisonOperator.Outside];

export const numberComparisonOperators = [
  ...BASE_OPERATORS,
  ...RANGE_OPERATORS,
  ...FILLED_OPERATORS,
  ...BETWEEN_OPERATORS,
];

export const dateComparisonOperators = [
  ...BASE_OPERATORS,
  ...RANGE_OPERATORS,
  ...FILLED_OPERATORS,
  ...BETWEEN_OPERATORS,
];

export const textComparisonOperators = [
  ...BASE_OPERATORS,
  ...CONTAINS_OPERATORS,
  ...STARTS_WITH_OPERATORS,
  ...ENDS_WITH_OPERATORS,
  ...FILLED_OPERATORS,
];

export const paramComparisonOperators = [...BASE_OPERATORS];
